(function ($) {
    /* eslint-disableddd */
    /* global Gauge */
    /* eslint camelcase: 0 */
    /* eslint no-var: 0 */

    var $resGameCalculator = $('.res-game-name');
    var $sensLevelName = $('.sens-level');

    // Mouse Sensitivity Convertor

    // Input validation
    var validateInput = function ($input) {
        var value = $input.val();
        if (value === '' || value.match(/[^0-9.]/g) ) {
            return true;
        }
        return false;
    };

    // Add level class & val on el
    var addLevelClass = function (val, el) {
        if (val <= 0) {
            el.removeClass('low medium high');
        } else if (val >= 1 && val <= 39) {
            el.removeClass('medium high');
            el.addClass('low');
            el.text('Low');
        } else if (val >= 40 && val < 80) {
            el.removeClass('low high');
            el.addClass('medium');
            el.text('Medium');
        } else if (val >= 80) {
            el.removeClass('medium high');
            el.addClass('high');
            el.text('High');
        }
    };

    // Add level class on el
    var addLevel = function (val, el) {
        if (val <= 0) {
            el.removeClass('low medium high');
        } else if (val >= 1 && val <= 39) {
            el.removeClass('medium high');
            el.addClass('low');
        } else if (val >= 40 && val < 80) {
            el.removeClass('low high');
            el.addClass('medium');
        } else if (val >= 80) {
            el.removeClass('medium high');
            el.addClass('high');
        }
    };

    // Chart gauge

    var opts = {
        angle: 0, // The span of the gauge arc
        lineWidth: 0.2, // The line thickness
        radiusScale: 1, // Relative radius
        pointer: {
            length: 0.4, // Relative to gauge radius
            strokeWidth: 0.045, // The thickness
            color: '#999dac' // Fill color
        },
        limitMax: false, // If false, max value increases automatically if value > maxValue
        limitMin: false, // If true, the min value of the gauge will be fixed
        staticZones: [
            {strokeStyle: '#3faf4e', min: 0, max: 39},
            {strokeStyle: '#ecfd06', min: 40, max: 79},
            {strokeStyle: '#fd4400', min: 80, max: 100},
        ],
        highDpiSupport: true, // High resolution support

    };

    var target = document.getElementById('chart-gauge');
    if (target !== null) {
        var gauge = new Gauge(target).setOptions(opts);
        gauge.maxValue = 100; // set max gauge value
        gauge.setMinValue(0); // Prefer setter over gauge.minValue = 0
        gauge.set(0); // set actual value
    }


    // Calc EDPI
    var calcSensitivity = function ($input_1, $input_2, $resVal) {
        if (validateInput($input_1) === false && validateInput($input_2) === false) {
            var val = $input_1.val() * $input_2.val();
            val = isNaN(val) ? 0 : val;
            $resVal.text(val);
            addLevel($resVal.text(), $resGameCalculator);
            addLevelClass($resVal.text(), $sensLevelName);
            gauge.set($resVal.text() > 100 ? 100 : $resVal.text());

        } else {
            $resVal.text('-');
            $resGameCalculator.removeClass('low medium high');
            $sensLevelName.removeClass('low medium high');
            gauge.set(0);
        }
    };




    var calcSensitivityFortnite = function ($input_1, $input_2, $resVal) {
        if (validateInput($input_1) === false && validateInput($input_2) === false) {
            var val = $input_1.val() * $input_2.val() * 0.01;
            val = isNaN(val) ? 0 : val;
            $resVal.text(val);
            addLevel($resVal.text(), $resGameCalculator);
            addLevelClass($resVal.text(), $sensLevelName);
            gauge.set($resVal.text() > 100 ? 100 : $resVal.text());

        } else {
            $resVal.text('-');
            $resGameCalculator.removeClass('low medium high');
            $sensLevelName.removeClass('low medium high');
            gauge.set(0);
        }
    };







    $('.calculator-section').each(function () {
        var $calculator = $(this);
        var $inputDpi = $('.input-dpi', $calculator);
        var $inputInGameSensitivity = $('.input-game-sensitivity', $calculator);
        var $itemSlider = $('.swiper-slide', $calculator);
        var $resVal = $('.res-val', $calculator);

        $inputDpi.add($inputInGameSensitivity).add($itemSlider).on('keyup click', function (e) {
            var $this = $(this);

            setTimeout(function () {
                var gameName = $itemSlider.filter('.selected').data('gameName');
                console.log(gameName);

                if ($this.val() !== '' && validateInput($this)) {
                    $this.addClass('invalid');
                } else {
                    $this.removeClass('invalid');
                }

                if (gameName === 'fortnite') {
                    console.log(1);
                    calcSensitivityFortnite($inputDpi, $inputInGameSensitivity, $resVal);
                } else {
                    calcSensitivity($inputDpi, $inputInGameSensitivity, $resVal);
                }
            }, 10);



            // calcSensitivity($inputDpi, $inputInGameSensitivity, $resVal);

        });
    });


})( jQuery );



